import React from 'react'
import store from '../../redux/store'
import SettingsSelect from '../../shared/components/SettingsSelect/SettingsSelect'

interface ActivityPopulationFieldProps {
    value: string
    onChange: (val: string) => void
    disabled?: boolean
    existingValue?: string
    error?: boolean
    helperText?: string
    required?: boolean
}

const ActivityPopulationField: React.FC<ActivityPopulationFieldProps> = ({
    value,
    onChange,
    disabled,
    existingValue,
    error,
    helperText,
    required,
}) => {
    const rawOptions: string[] = store.getState()?.settings?.vmSubpopulations || []
    const options = rawOptions.map((s) => ({ value: s, label: s }))

    return (
        <SettingsSelect
            value={value}
            onChange={onChange}
            options={options}
            placeholder="Select Population"
            disabled={disabled}
            existingValue={existingValue}
            error={error}
            helperText={helperText}
            required={required}
        />
    )
}

export default ActivityPopulationField
